module.exports = __webpack_public_path__ + "img/img_sign.8110d331.png";